import { useTranslations } from '@vocab/react';
import {
  Alert,
  Box,
  Columns,
  Column,
  Stack,
  Heading,
  Text,
} from 'braid-design-system';

import translations from '../.vocab';

import { HooraySvg } from './HooraySvg';

export interface PromoCodeSuccessAlertProps {
  promoCode: string;
  free: boolean;
}

const PromoCodeSuccessAlert = ({
  promoCode,
  free,
}: PromoCodeSuccessAlertProps) => {
  const { t } = useTranslations(translations);
  const successAlertText = t('promo-code-input-success', { promoCode });

  return (
    <Stack space="medium">
      <Alert tone="positive">
        <Text>{successAlertText}</Text>
      </Alert>

      {free && (
        <Box
          background="infoLight"
          borderRadius="standard"
          data-testid="zero-balance"
          padding="medium"
        >
          <Columns alignY="center" collapseBelow="tablet" space="medium">
            <Column width="1/5">
              <HooraySvg />
            </Column>
            <Column>
              <Stack space="medium">
                <Heading level="3">
                  {t('promo-code-input-free-heading-text')}
                </Heading>
                <Text>{t('promo-code-input-free-description-text')}</Text>
              </Stack>
            </Column>
          </Columns>
        </Box>
      )}
    </Stack>
  );
};

export { PromoCodeSuccessAlert };
